import React, { useEffect, useState } from "react";
import axios from "axios";
import { AmbikaChefAPI } from "./config";

// Cache for fetched status codes to avoid redundant API requests
let cachedStatusCodes = null;

const staticStatusCodes = [
  { id: 1, code: "U", name: "Urgent", color_code: "#FF6969" },
  { id: 2, code: "P", name: "Packing", color_code: "#FF6969" },
  { id: 3, code: "O", name: "Order Placed with O", color_code: "#FF6969" },
  { id: 4, code: "Z", name: "Food Partially Ready (Z)", color_code: "#FF6969" },
];

const StatusBadge = ({ product, status, orderNo }) => {
  const [productStatusCode, setProductStatusCode] = useState([]);

  useEffect(() => {
    if (cachedStatusCodes) {
      setProductStatusCode(cachedStatusCodes);
      return;
    }
    const token = localStorage.getItem("ambikaChefUserToken");
    if (!token) return;

    axios
      .get(`${AmbikaChefAPI}/vendor/productStatusCode`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res?.data?.data) {
          cachedStatusCodes = res.data.data;
          setProductStatusCode(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching product status codes:", err);
      });
  }, []);

  const renderStatusCircle = (statusId) => {
    if (!statusId) return null;
    const match = productStatusCode.find((s) => s.id === Number(statusId));
    if (!match) return null;

    return (
      <div
        key={`status-${statusId}`}
        className="status-icon"
        style={{
          backgroundColor: match.color_code,
          width: "22px",
          height: "22px",
          borderRadius: "50%",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "5px",
          cursor: "pointer",
        }}
        title={match.name}
      />
    );
  };

  const renderStaticIcon = (code, tooltip) => {
    return (
      <div
        key={`static-${code}`}
        className="status-icon"
        style={{
          backgroundColor: "white",
          color: "black",
          border: "1.5px solid #212529",
          width: "22px",
          height: "22px",
          borderRadius: "50%",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "bold",
          fontSize: "11px",
          marginRight: "5px",
          cursor: "pointer",
        }}
        title={tooltip}
      >
        {code}
      </div>
    );
  };

  const icons = [];

  // 1. Color status round
  const resolvedStatus = status || product?.status;
  if (resolvedStatus && typeof resolvedStatus === "number") {
    const circle = renderStatusCircle(resolvedStatus);
    if (circle) icons.push(circle);
  }

  // 2. Urgent (U)
  if (product?.is_urgent === 1 || product?.is_urgent !== 0) {
    icons.push(renderStaticIcon("U", "Urgent"));
  }

  // 3. Packing (P)
  if (product?.is_parcel === 1 || product?.is_parcel !== 0) {
    icons.push(renderStaticIcon("P", "Packing"));
  }

  // 4. Order Placed (O) - automatically for customer orders starting with WEBIO
  const resolvedOrderNo = orderNo || product?.orderNo || product?.order_no;
  const isCustomerOrder = resolvedOrderNo && String(resolvedOrderNo).includes("WEBIO");
  if (isCustomerOrder || resolvedStatus === "O" || product?.status === "O") {
    icons.push(renderStaticIcon("O", "Order Placed with O"));
  }

  // 5. Food Partially Ready (Z)
  if (resolvedStatus === 5 || resolvedStatus === "Z" || product?.status === "Z") {
    icons.push(renderStaticIcon("Z", "Food Partially Ready (Z)"));
  }

  return (
    <div className="d-inline-flex align-items-center flex-shrink-0">
      {icons}
    </div>
  );
};

export default StatusBadge;
